import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React, { useState } from 'react'
import styles from './Avatar.module.scss'

// Generates initials from a full name string
function initials(name) {
  if (!name) return '?'
  const parts = name.trim().split(/\s+/)
  if (parts.length === 1) return parts[0][0].toUpperCase()
  return (parts[0][0] + parts[1][0]).toUpperCase()
}

// Generates a stable hue from a name string for the fallback color
function hue(name) {
  if (!name) return 220
  let h = 0
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) % 360
  return h
}

/**
 * Avatar — shows a photo if src is valid, otherwise a colored initials circle.
 * Props:
 *   src   — image URL (optional)
 *   name  — person's full name (for initials + color fallback)
 *   size  — 'sm' | 'md' | 'lg'  (default 'md')
 */
export default function Avatar({ src, name, size = 'md' }) {
  useInterfaceLanguage();
  const [imgError, setImgError] = useState(false)
  const showImg = src && !imgError

  const bg = `hsl(${hue(name)}, 55%, 60%)`

  return (
    <div
      className={`${styles.avatar} ${styles[size]}`}
      style={showImg ? undefined : { background: bg }}
      title={tr(name)}
    >
      {showImg
        ? <img src={src} alt={tr(name)} className={styles.img} onError={() => setImgError(true)} />
        : <span className={styles.initials}>{initials(name)}</span>
      }
    </div>
  )
}
